import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Engenheiro() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('eng_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('eng_description')}
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-2xl font-semibold mb-6">{t('eng_title')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="bg-blue-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-4 text-blue-800">{t('eng_description')}</h3>
                <div className="space-y-3">
                  {[
                    t('eng_resp1'),
                    t('eng_resp2'),
                    t('eng_resp3'),
                    t('eng_resp4'),
                    t('eng_resp5'),
                    t('eng_resp6'),
                    t('eng_resp7'),
                    t('eng_resp8')
                  ].map((responsibility, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-blue-600"></i>
                      </div>
                      <span className="text-sm">{responsibility}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/304216a7520ae815c6736a111de1ee6c.jpg"
                alt="Site Engineer"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-2xl font-semibold mb-6">{t('eng_qualities')}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className="ri-user-line text-2xl text-blue-600"></i>
              </div>
              <ul className="space-y-2">
                {[
                  t('eng_qual1'),
                  t('eng_qual2'),
                  t('eng_qual3'),
                  t('eng_qual4'),
                  t('eng_qual5'),
                  t('eng_qual6')
                ].map((quality, index) => (
                  <li key={index} className="flex items-center space-x-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-blue-600"></i>
                    </div>
                    <span className="text-sm">{quality}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/diagnostico"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_diagnosis')}
          </Link>
          <Link 
            to="/seguranca"
            className="flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_safety')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
